import resolveModel from "react-redux-form/lib/utils/resolve-model";
import getModel from "react-redux-form/lib/utils/get-model";
import get from "react-redux-form/lib/utils/get";
import getForm from "react-redux-form/lib/utils/get-form";
import getFieldFromState from "react-redux-form/lib/utils/get-field-from-state";
import initialFieldState from "react-redux-form/lib/constants/initial-field-state";
import { compose } from "recompose";
import { connect } from "react-redux";

function mapStateToProps(state, { model }) {
  const modelString = getModel(model, state);

  const form = getForm(state, modelString);

  const formValue = form.$form;
  const fieldValue = getFieldFromState(state, modelString) || initialFieldState;

  return {
    model: modelString,
    modelValue: get(state, modelString),
    formValue,
    fieldValue,
  };
}

export default compose(resolveModel, connect(mapStateToProps));
